import type { NodeMock, StatePreset } from "../mock-types";

export const readyUpMock: NodeMock = {
  label: "Ready Up",
  description: "Players confirm they are ready to play",
  state: (players) => ({
    readyPlayers: [players[0]?.userId, players[2]?.userId].filter(Boolean),
    notReadyPlayers: players
      .slice(1)
      .filter((_, i) => i !== 1)
      .map((p) => p.userId),
  }),
  config: {
    timeoutSeconds: 30,
    requiredPercentage: 1.0,
    labels: {
      title: "Match Found",
      subtitle: "Confirm you are ready to play",
      buttonText: "Ready",
    },
  },
};

export const readyUpPresets: StatePreset[] = [
  {
    label: "Fresh",
    build: ({ players }) => ({
      state: { readyPlayers: [], notReadyPlayers: players.map((p) => p.userId) },
    }),
  },
  {
    label: "Your Turn",
    build: ({ players, viewerId }) => ({
      state: {
        readyPlayers: players.filter((p) => p.userId !== viewerId).map((p) => p.userId),
        notReadyPlayers: [viewerId],
      },
    }),
  },
  {
    label: "All Ready",
    build: ({ players }) => ({
      state: { readyPlayers: players.map((p) => p.userId), notReadyPlayers: [] },
    }),
  },
];
